module.exports = __webpack_public_path__ + "static/img/display_lcd_azul_16x2-1.3d091d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/display_lcd_azul_16x2-1.svg
// module id = oF/O
// module chunks = 0